import { Button } from '@repo/ui';
import { ArrowDown, ArrowLeft, ArrowRight, ArrowUp, GripVertical } from 'lucide-react';
import type { ButtonHTMLAttributes } from 'react';

export const OrderMoveControls = ({
  title,
  first,
  last,
  disabled,
  onMove,
  handleProps,
  orientation = 'vertical',
}: {
  title: string;
  first: boolean;
  last: boolean;
  disabled: boolean;
  onMove: (direction: 'UP' | 'DOWN') => void;
  handleProps?: ButtonHTMLAttributes<HTMLButtonElement>;
  orientation?: 'vertical' | 'horizontal';
}) => (
  <div
    className={`flex shrink-0 items-center gap-1 ${orientation === 'horizontal' ? 'justify-center' : ''}`}
  >
    {handleProps ? (
      <Button
        {...handleProps}
        type="button"
        variant="ghost"
        size="sm"
        className="cursor-grab px-2 active:cursor-grabbing"
        disabled={disabled}
        aria-label={`${title} 순서 이동`}
        title="끌어서 순서 변경"
      >
        <GripVertical aria-hidden="true" />
      </Button>
    ) : null}
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="px-2"
      aria-label={`${title} ${orientation === 'horizontal' ? '앞으로' : '위로'}`}
      title={orientation === 'horizontal' ? '앞으로 이동' : '위로 이동'}
      disabled={disabled || first}
      onClick={() => onMove('UP')}
    >
      {orientation === 'horizontal' ? (
        <ArrowLeft aria-hidden="true" />
      ) : (
        <ArrowUp aria-hidden="true" />
      )}
    </Button>
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="px-2"
      aria-label={`${title} ${orientation === 'horizontal' ? '뒤로' : '아래로'}`}
      title={orientation === 'horizontal' ? '뒤로 이동' : '아래로 이동'}
      disabled={disabled || last}
      onClick={() => onMove('DOWN')}
    >
      {orientation === 'horizontal' ? (
        <ArrowRight aria-hidden="true" />
      ) : (
        <ArrowDown aria-hidden="true" />
      )}
    </Button>
  </div>
);
